import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/app/auth';

export function ProtectedRoute() {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
